import { API_URL }  from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';
import { getSegmento } from "../util/generics.js";

let request = () => (axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json'
    }
}))

export default class UsuariosRequest {

    /**
     * Llamada al endpoint de django para listar los usuarios
     * @param: filtros. información del usuario para filtros
     * @return: nada
     */
    static ListarUsuarios(filtros) {
        return middleware.hasAuth(() => request().get(`usuarios`, {
            params: {
                busqueda: filtros?.busqueda,
                region: filtros?.region_id,
                sucursal: filtros?.sucursal_id,
                estatus_usuario: filtros?.estatus_id,
                configurado: filtros?.configurado_id,
                page: filtros?.page,
                segmento: getSegmento()
            }
        }))
    }

    /**
     * Llamada al endpoint de django para crear un usuario en la
     * tabla del sistema de inventario
     */
    static CrearUsuarioAuth() {
        return middleware.hasAuth(() => request().post(`crearUsuario`));
    }

    /**
     * Llamada al endpoint de django para configurar / editar un usuario
     * @param: obj. id del usuario de caffenio auth y su información 
     * @return: nada
     */
    static ActualizarUsuario(obj) {
        return middleware.hasAuth(() => request().put(`usuarios/${obj.id}/editar`, obj))
    }

    /**
     * Método para buscar las regiones, sucursales y puntos de venta del usuario
     * @param {int} id Id del usuario a buscar 
     */
    static CatalogosUsuario(id){
        return middleware.hasAuth(() => request().get(`/catalogos_usuario?id=${id}`))
    }
}